import { render } from "./resourceLabel.vue?vue&type=template&id=32eca769&ts=true"
import script from "./resourceLabel.vue?vue&type=script&lang=ts"
export * from "./resourceLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__